import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store";

export const baseSelector = (state: RootState) => state.user;

export const userPermissionSelector = (page: string) =>
  createSelector(baseSelector, (user) => {
    return user.userAppPermissions[page]?.hasControl ?? false;
  });

export const userRolesSelector = createSelector(
  baseSelector,
  (user) => user.roles
);
